import { useCallback, useState } from "react";
import {
  HINT_POINT_COST,
  HINT_POINTS_PACK_AMOUNT,
} from "../lib/hintPointsConstants";
import {
  deductGuestFreeHint,
  ensureGuestFreeHintsInitialized,
  getGuestFreeHintBalance,
  hasGuestFreeHintWallet,
  isGuestHintsForfeited,
} from "../lib/guestHintsStorage";

export function useHintPointsManager() {
  const initial = (() => {
    try {
      if (isGuestHintsForfeited()) return 0;
      return ensureGuestFreeHintsInitialized();
    } catch {
      return 0;
    }
  })();
  const [pointBalance, setPointBalance] = useState(initial);

  const refreshBalance = useCallback(async () => {
    const next = isGuestHintsForfeited()
      ? 0
      : hasGuestFreeHintWallet()
        ? getGuestFreeHintBalance()
        : ensureGuestFreeHintsInitialized();
    setPointBalance(next);
    return next;
  }, []);
  const refreshPackage = useCallback(async () => {}, []);
  const refreshAll = useCallback(async () => {
    await refreshBalance();
  }, [refreshBalance]);
  const applyPointBalance = useCallback((n) => {
    if (Number.isFinite(Number(n))) setPointBalance(Number(n));
  }, []);
  const spendPoints = useCallback(async ({ pointsConsumed } = {}) => {
    const cost = Number(pointsConsumed);
    const pointsToSpend =
      Number.isFinite(cost) && cost > 0 ? Math.floor(cost) : HINT_POINT_COST;
    if (isGuestHintsForfeited()) {
      throw new Error("Insufficient assistant coins.");
    }
    const current = hasGuestFreeHintWallet()
      ? getGuestFreeHintBalance()
      : ensureGuestFreeHintsInitialized();
    if (current < pointsToSpend) {
      throw new Error("Insufficient assistant coins.");
    }
    const next = deductGuestFreeHint(pointsToSpend);
    setPointBalance(next);
    return { pointBalance: next, pointsConsumed: pointsToSpend, spentFromGuest: true };
  }, []);
  const purchase = useCallback(async () => ({ success: false, error: "web_stub" }), []);
  const getPackPrice = useCallback(() => null, []);

  return {
    pointBalance,
    balanceLoading: false,
    balanceLoaded: true,
    applyPointBalance,
    spendPoints,
    packAmount: HINT_POINTS_PACK_AMOUNT,
    isProcessing: false,
    isAuthenticated: false,
    hasPoints: pointBalance > 0,
    isIapAvailable: false,
    packagesLoading: false,
    refreshBalance,
    refreshPackage,
    refreshAll,
    purchase,
    getPackPrice,
  };
}
